import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CareState } from './models/care-state.models';

export const selectCareState = createFeatureSelector<CareState>('care');

export const selectCareRecipients = createSelector(
  selectCareState,
  (state: CareState) => state.careRecipients
);

export const selectSelectedRecipientId = createSelector(
  selectCareState,
  (state: CareState) => state.selectedRecipientId
);

export const selectSelectedRecipient = createSelector(
  selectCareRecipients,
  selectSelectedRecipientId,
  (recipients, selectedId) => recipients.find(r => r.user_id === selectedId) ?? null
);

export const selectCareLoading = createSelector(
  selectCareState,
  (state: CareState) => state.loading
);

export const selectCareError = createSelector(
  selectCareState,
  (state: CareState) => state.error
);
